/* eslint-disable @typescript-eslint/camelcase */
import { GetOperatorFields } from 'modules/operators/interfaces';

export const initialEdit: GetOperatorFields = {
  company: { company_uuid: '', company_name: '' },
  operator_uuid: '',
  first_name: '',
  last_name: '',
  email: '',
  mobile_phone: '',
  phone: '',
  language: 'pt-br',
  role: '',
  mfa_required: true,
  blocked: false,
  mfa_configured: false,
  updated_date: '',
  created_date: '',
  created_by_operator: {
    first_name: '',
    last_name: '',
    email: '',
    operator_uuid: '',
  },
  updated_by_operator: {
    first_name: '',
    last_name: '',
    email: '',
    operator_uuid: '',
  },
  permission_roles: [
    {
      role_uuid: '',
    },
  ],
};
